<template>
  <div>
    <terminal-sequence-card
      v-for="(sequence, i) in data"
      :key="sequence.id"
      :sequence="sequence"
      :last-in-list="i === data.length - 1"
      @click="handleClick"
    />
  </div>
</template>

<script>
import TerminalSequenceCard from './terminal-sequence-card.vue'

export default {
  name: 'DynamicSequenceCollection',
  components: {
    TerminalSequenceCard
  },
  emits: ['click'],
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    },
    rawData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    title () {
      if (this.rawData.options) {
        return this.rawData.options.title
      }

      return this.rawData.title || ''
    }
  },
  methods: {
    handleClick (data) {
      const event = {
        type: this.rawData.entityClass,
        event: this.rawData.event,
        data
      }

      this.$emit('click', event)
    }
  }
}
</script>
